import { TrendingUp } from "lucide-react";
import { Link } from "react-router-dom";

export function Logo({ className = "", to = "/", showText = true }) {
  return (
    <Link to={to} className={`flex items-center gap-2 group ${className}`} data-testid="brand-logo">
      <div className="relative h-9 w-9 rounded-xl bg-gradient-to-br from-primary to-accent flex items-center justify-center shadow-lg shadow-primary/30">
        <TrendingUp className="h-5 w-5 text-white" strokeWidth={2.5} />
      </div>
      {showText && (
        <div className="leading-none">
          <span className="font-display font-extrabold text-lg tracking-[0.18em]">KRE<span className="text-accent">O</span>NIS</span>
        </div>
      )}
    </Link>
  );
}
